export default "__VITE_ASSET__gWeqL2v$__"